<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['saleEchartsData'],
    data() {
        return {
            orderPayCustomerYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5],
            orderPayMoneyYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            xdisplaydata: [11, 13, 14, 17, 24, 28, 29, 23, 20, 19, 17, 15]
        }
    },
    watch: {
        saleEchartsData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.saleEchartsData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.orderPayCustomerYdata = Edata.orderPayCustomerYdata
            this.orderPayMoneyYdata = Edata.orderPayMoneyYdata
            this.xdisplaydata = Edata.xdisplaydata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#41CCF0', '#67C23A'],
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['付费用户数', '付费金额(元)'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '付费用户数',
                        type: 'line',
                        data: this.orderPayCustomerYdata
                    },
                    {
                        name: '付费金额(元)',
                        type: 'line',
                        data: this.orderPayMoneyYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>